var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x9C\xD0\xB0\xD0\xBB\xD0\xB5\xD0\xBD\xD1\x8C\xD0\xBA\xD0\xB8\xD0\xB5 / \xD0\x9F\xD0\xBB\xD0\xB0\xD1\x82\xD0\xB5\xD0\xB6\xD0\xB8 / \xD0\x9F\xD0\xBB\xD0\xB0\xD1\x82\xD0\xB5\xD0\xB6\xD0\xB8 \xD0\xB2 \xD1\x81\xD1\x82\xD1\x80\xD0\xB0\xD0\xBD\xD0\xB5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.375 22.3333L1.375 25V14.3333L7.66887 12.2354M9.375 22.3333L17.375 25M9.375 22.3333V15.6667M17.375 25L25.375 22.3333V11.6667L18.2572 14.0393M17.375 25V15.6667M20.0417 7.98194C20.0417 14.3333 13.375 19.6667 13.375 19.6667C13.375 19.6667 6.70833 14.3333 6.70833 7.98194C6.70833 4.12431 9.69156 1 13.375 1C17.0584 1 20.0417 4.12431 20.0417 7.98194ZM16.0417 7.66667C16.0417 9.13943 14.8478 10.3333 13.375 10.3333C11.9022 10.3333 10.7083 9.13943 10.7083 7.66667C10.7083 6.19391 11.9022 5 13.375 5C14.8478 5 16.0417 6.19391 16.0417 7.66667Z",
    stroke: "#AAACAB",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.2bbca9cd222a7b79bf908a43276dce78.svg";
export { ForwardRef as ReactComponent };